import {
  GET_ADMIN_BILLING_EVENTS,
  GET_ADMIN_BILLING_EVENTS_SUCCESS,
  GET_ADMIN_BILLING_EVENTS_ERROR,
  GET_BILLING_EVENTS_FILTER_OPTIONS,
  GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS,
  GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR
} from "./actionTypes"

export const getAdminBillingEvents = (query_params) => {
  return {
    type: GET_ADMIN_BILLING_EVENTS,
    payload: query_params,
  }
}

export const getAdminBillingEventsSuccess = (event, meta = {}) => ({
  type: GET_ADMIN_BILLING_EVENTS_SUCCESS,
  payload: event,
  meta
})

export const getAdminBillingEventsError = (error) => ({
  type: GET_ADMIN_BILLING_EVENTS_ERROR,
  payload: error
})

export const getBillingEventsFilterOptions = () => ({
  type: GET_BILLING_EVENTS_FILTER_OPTIONS
})

export const getBillingEventsFilterOptionsSuccess = (options) => ({
  type: GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS,
  payload: options
})

export const getBillingEventsFilterOptionsError = (error) => ({
  type: GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR,
  payload: error
})
